import axios from 'axios';
import {flashMessage} from 'redux-flash';
import Config from '../../config';

export function getGlobalsForWorkspace(parentWorkspaceId) {
    return async (dispatch) => {
        const structure = await axios.get(Config.api.endpoint + 'api/content/structure/' + parentWorkspaceId + '/page',Config.getApiConfig());
        const blocks = await axios.get(Config.api.endpoint + 'api/content/structure/' + parentWorkspaceId + '/block',Config.getApiConfig());

        dispatch({
            type: 'GET_GLOBALS_FOR_WORKSPACE',
            payload: {
                structure: structure.data,
                blocks: blocks.data,
                parentWorkspaceId: parentWorkspaceId,
            }
        });

        return Promise.resolve({
            structure: structure.data,
            blocks: blocks.data,
            parentWorkspaceId: parentWorkspaceId
        });
    }
}

export function getGlobals() {
    return async (dispatch) => {
        const contentDefinition = await axios.get(Config.api.endpoint + 'api/Content/definition',Config.getApiConfig()).catch(error => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
               //  console.log(error.response.data);
               // console.log(error.response.status);
               //  console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                if (Config.renderer==="backend" && Config.getToken()){
                    //Switching from pilot  to live and back, was problem with token
                    //so on failure we clean storage
                    //console.log("request",error.request);
                    Config.clearStorage();
                }
            } else {
                // Something happened in setting up the request that triggered an Error
               // console.log('Error', error.message);
            }
            //console.log(error.config);

        });
        //TODO field definitions
        //const fieldDefinition = await axios.get(Config.api.endpoint + 'api/crud/fielddefinition',Config.getApiConfig());
        const language = await axios.get(Config.api.endpoint + 'api/Language',Config.getApiConfig());
        const global = await axios.get(Config.api.endpoint + 'api/global/field',Config.getApiConfig());

        dispatch({
            type: 'GET_GLOBALS',
            payload: {
                contentDefinitions: contentDefinition.data,
          //      fieldDefinitions: fieldDefinition.data,
                languages: language.data,
                global: global.data
            }
        });

        return Promise.resolve({
            contentDefinitions: contentDefinition.data,
            //fieldDefinitions: fieldDefinition.data,
            languages: language.data,
            global: global.data
        });
    }
}

export function getSingle(key, languageCode) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/global/field/' + key + '/' + languageCode,Config.getApiConfig()).then(response => {
            if (response.data) {
                let data = '';

                try {
                    data = JSON.parse(response.data.data);
                } catch (e) {
                    data = response.data.data;
                }

                dispatch({
                    type: 'GLOBAL_FIELD_GET_SINGLE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'GlobalFieldForm',
                        keepDirty: undefined
                    },
                    payload: {
                        data: data,
                        key: response.data.key,
                        languageId: languageCode
                    }
                });

                return response;
            }
        })
    }
}

export function patch(key, languageCode, value) {

    return (dispatch) => {
        return axios.patch(Config.api.endpoint + 'api/global/field/' + key + '/' + languageCode, JSON.stringify(value), Config.getApiConfig({headers: {'Content-Type': 'application/json-patch+json'}})).then(response => {
            if (response.data) {
                dispatch(getSingle(key, languageCode));

                dispatch({
                    type: 'GLOBAL_FIELD_PATCH_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Global field updated!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function getAllLanguage(languageCode) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/global/field/' + languageCode,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_GET_ALL_LANGUAGE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                return response;
            }
        })
    }
}

export function getAll() {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/global/field',Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_GET_ALL_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                return response;
            }
        })
    }
}

export function post(values) {
    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/global/field', values,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Global field created!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function destroy(key) {
    return (dispatch) => {
        return axios.delete(Config.api.endpoint + 'api/global/field/' + key,Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'GLOBAL_FIELD_DESTROY_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Global field deleted!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/core/admin/store/actions/global.js